export enum CommentsCategory {
  Assets = 'Assets',
  AssetOperationTimes = 'AssetOperationTimes',
  POMQuestions = 'POMQuestions',
  MaterialOrders = 'MaterialOrders',
  HrocRegionalManagerKpis = 'HrocRegionalManagerKpis',
  ProcessWorkOrders = 'ProcessWorkOrders'
}

export enum CommentStatus {
  New = 'New',
  Edited = 'Edited'
}

type BaseCommentDto = {
  commentId: string
  commentsCategory: CommentsCategory
  commentsCategoryInstanceId: string
  value: string
  createdOn: string
  createdBy: string
}

type NewCommentDto = BaseCommentDto & {
  status: CommentStatus.New
}

type EditedCommentDto = BaseCommentDto & {
  status: CommentStatus.Edited
  updatedOn: string
  updatedBy: string
}

export type CommentDto = NewCommentDto | EditedCommentDto

export type CommentPayloadDto = {
  value: string
}
